import * as THREE from 'three';
import type { DecorPlacement } from '../../editor/layout-types.js';
import { SharedGeometries } from './shared-geometries.js';
import { mat } from './palette.js';

export class DecorEditorLayer {
  readonly root = new THREE.Group();
  private items = new Map<string, THREE.Group>();

  sync(decor: DecorPlacement[]): void {
    const seen = new Set<string>();
    for (const d of decor) {
      seen.add(d.id);
      let g = this.items.get(d.id);
      if (!g) {
        g = new THREE.Group();
        const pot = new THREE.Mesh(SharedGeometries.pot(), mat(0x5c4033));
        pot.position.y = 0.28;
        const bush = new THREE.Mesh(SharedGeometries.bush(), mat(0x3d6b3d));
        bush.position.y = 0.9;
        pot.castShadow = true;
        bush.castShadow = true;
        g.add(pot, bush);
        g.userData.decorId = d.id;
        this.root.add(g);
        this.items.set(d.id, g);
      }
      g.position.set(d.x, 0, d.z);
      g.rotation.y = d.rotationY;
    }
    for (const [id, g] of this.items) {
      if (!seen.has(id)) {
        this.root.remove(g);
        this.items.delete(id);
      }
    }
  }
}
